module.exports = __webpack_public_path__ + "img/IconaXLS_Color.4b8e1643.svg";